const AppleLoginButton = () => {
  return null;
};

export default AppleLoginButton;
